import React from "react";
import { BACKEND_URL } from "../util/api";

const About = ({ data }) => {
  const {
    profile,
    office,
    constituency,
    about,
  } = data || {};

  // Prevent errors while API data is loading
  if (!profile || !office || !constituency || !about) {
    return null;
  }

  return (
    <section
      className="about-section section-padding"
      id="about"
      aria-labelledby="about-title"
    >
      <div className="container about-grid">

        {/* =========================
            IMAGE
        ========================== */}
        <div className="about-image">

          <div className="about-image-main">
            <img
              src={BACKEND_URL +"/storage/" + profile.image}
              alt={profile.full_name}
              loading="lazy"
            />
          </div>

          {/* =========================
              ASSEMBLY EXPERIENCE
          ========================== */}
          <div className="about-experience">

            <span>
              {office.institution_value
                ?.match(/\d+/)?.[0] || "01"}
            </span>

            <small>
              {office.institution_value
                ?.replace(/\d+/, "")
                .trim()
                .toUpperCase()}
            </small>

          </div>

        </div>

        {/* =========================
            CONTENT
        ========================== */}
        <div className="about-content">

          <p className="section-label">
            <span />
            ABOUT THE HONOURABLE
          </p>

          <h2 id="about-title">
            {about.title}{" "}
            <em>{about.emphasis}</em>
          </h2>

          <p className="lead">
            {about.lead}
          </p>

          <p>
            {about.description}
          </p>

          {/* =========================
              CONSTITUENCY DETAILS
          ========================== */}
          <div className="about-details">

            <div>
              <span>LOCAL GOVERNMENT</span>

              <strong>
                {constituency.local_government}
              </strong>
            </div>

            <div>
              <span>TOWN</span>

              <strong>
                {constituency.town}
              </strong>
            </div>

          </div>

      {/*     <a
            href="#contact"
            className="text-link"
          >
            Learn More About the Honourable

            <span aria-hidden="true">
              →
            </span>
          </a> */}

        </div>
      </div>
    </section>
  );
};

export default About;